__turbopack_context__.v({
  "button": "SpotStampOverlay-module__aA6Oka__button",
  "checkmarkContainer": "SpotStampOverlay-module__aA6Oka__checkmarkContainer",
  "container": "SpotStampOverlay-module__aA6Oka__container",
});
